/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import { ExpandableSection, SpaceBetween } from '@amzn/awsui-components-react';
import EventFeedback from './EventFeedback';
import ChallengeFeedback from './ChallengeFeedback';

interface ExpandableFeedbackProps {
  headerText: string;
  isEvent?: boolean;
  challengeId?: string;
  'data-testid'?: string;
}

const ExpandableFeedback: React.FC<ExpandableFeedbackProps> = ({
  headerText,
  isEvent = true,
  challengeId,
  ...rest
}) => {
  return (
    <ExpandableSection
      variant="container"
      headerText={headerText}
      defaultExpanded
      data-testid={rest['data-testid'] || null}
    >
      <SpaceBetween direction="vertical" size="m">
        {isEvent ? <EventFeedback /> : <ChallengeFeedback challengeId={challengeId} />}
      </SpaceBetween>
    </ExpandableSection>
  );
};

export default ExpandableFeedback;
